import BaseApiService from './api.base.service'

class ReservedAreaParticipantApiService extends BaseApiService {
  constructor() {
    super('AreaRiservataFruitore')
  }

  getCorsiAbbonamentoELearning() {
    return this.callGet(`/getCorsiAbbonamentoELearning`)
  }

  EcPassRaSearch(search) {
    return this.callGet(`/EcPassRaSearch/`, { search: search })
  }

  getEcPassClienteAcquisto(subscriptionId) {
    return this.callGet(`/ecPassClienteAcquisto/`, {
      subscriptionId: subscriptionId,
    })
  }
  getLiveLink() {
    return this.callGet('/GetLiveLink')
  }

  getUserCF() {
    return this.callGet('/GetUserCF')
  }
}

export const reservedAreaParticipantApi =
  new ReservedAreaParticipantApiService()
